import { useOrderDialogUrlState } from "./hooks/useOrderDialogUrlState"
import { useCreateOrderUser } from "./hooks/useCreateOrderUser"
import { CreateOrderDialog } from "./CreateOrderDialog"

export function CreateOrderDialogHost() {
    const { isOpen, config, closeDialog } = useOrderDialogUrlState()

    if (!isOpen) return null

    return <CreateOrderDialogHostOpen config={config} closeDialog={closeDialog} />
}

type CreateOrderDialogHostOpenProps = Readonly<{
    config: ReturnType<typeof useOrderDialogUrlState>["config"]
    closeDialog: () => void
}>

function CreateOrderDialogHostOpen({ config, closeDialog }: CreateOrderDialogHostOpenProps) {
    const mode = config.mode ?? "create"
    const { onBehalf, setOnBehalf } = useCreateOrderUser({ mode })

    return (
        <CreateOrderDialog
            open
            orderId={config.orderId}
            mode={mode}
            dialogType={config.dialogType}
            activeOrderTab={config.activeOrderTab}
            flowConfig={config.flowConfig}
            onClose={() => closeDialog()}
            isOnBehalfCompleted={onBehalf}
            setIsOnBehalfCompleted={setOnBehalf}
        />
    )
}
